module.exports = __webpack_public_path__ + "static/media/people-1.57927a2a.svg";